exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-icon[data-v-68f9d943] {\n  width: 1.5rem;\n  margin-right: 0.5rem;\n  transform: translateY(2px);\n}", ""]);

// exports
